export enum MontazaStatusEnum {
  InProgress = 'InProgress',
  Idle = 'Idle',
  Done = 'Done',
}



// WEBPACK FOOTER //
// ./src/app/enums/montaza-status.enum.ts